module.exports = __webpack_public_path__ + "static/img/Alexanne.cac1222.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/staff/Alexanne.jpg
// module id = 197
// module chunks = 1